import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../css/new.css'; // Custom styles


import logo from '../images/logo.jpg'

function FullNavbar() {
  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="brand">
        
        <h1> 🦷 NATURAL TOOTH</h1>
        
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav"  />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/about">About US </Nav.Link>
             
            <Nav.Link as={Link} to="/services">Treatments</Nav.Link>
            <Nav.Link as={Link} to="/contact">Contact US </Nav.Link>
            <Nav.Link as={Link} to="/gallery">Gallery</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default FullNavbar;
